// Tiny module: province types + label maps only. Route head()/components import
// from here so the 77-province corpus stays out of the client entry bundle.
export type ProvinceRegion =
  | "central"
  | "north"
  | "northeast"
  | "east"
  | "west"
  | "south";

export type ProvinceBranch = "bangkok" | "phuket" | "chiangmai" | "khonkaen" | "haadyai";

export interface ThaiProvince {
  slug: string;
  nameTh: string;
  nameEn: string;
  region: ProvinceRegion;
  /** approx provincial capital geo */
  geo: { lat: number; lng: number };
  /** office that ships docs / sends couriers to this province */
  nearestBranch: ProvinceBranch;
}

export const REGION_LABEL: Record<ProvinceRegion, string> = {
  central: "ภาคกลาง",
  north: "ภาคเหนือ",
  northeast: "ภาคตะวันออกเฉียงเหนือ (อีสาน)",
  east: "ภาคตะวันออก",
  west: "ภาคตะวันตก",
  south: "ภาคใต้",
};

export const BRANCH_LABEL: Record<ProvinceBranch, string> = {
  bangkok: "สำนักงานกรุงเทพ",
  phuket: "สำนักงานภูเก็ต",
  chiangmai: "ทีมพันธมิตรเชียงใหม่",
  khonkaen: "ทีมพันธมิตรขอนแก่น",
  haadyai: "ทีมพันธมิตรหาดใหญ่",
};
